import { CollectionName } from '../../constants';
import { AssetCategory } from '../../models';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const oldKey = 'insuranceAgreement';
const newKey = 'insuranceDocument';

const migrateAssetInsurance = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };

  if (data.category === AssetCategory.BANK_CELLS && data[oldKey]) {
    newData[newKey] = data[oldKey];
    delete newData[oldKey];
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateAssetInsurance },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration6: MigrationType = {
  migrate,
  version: 7,
};
